import { render, staticRenderFns } from "./management.vue?vue&type=template&id=6948fad8&scoped=true"
import script from "./management.vue?vue&type=script&lang=js"
export * from "./management.vue?vue&type=script&lang=js"
import style0 from "./management.vue?vue&type=style&index=0&id=6948fad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6948fad8",
  null
  
)

export default component.exports